import React from "react";
import { useGetQueryData } from "@/utils/react-query-hooks/general";
import { __IsSuperAdmin } from "@/utils/accessControl";
import { VolunteerDashboard } from "@/pageTpls/Playground/pages/VolunteerDashboard";

const isOoloilabsSuperAdmin = (user) =>
  __IsSuperAdmin(user) && user?.email?.endsWith("@getdots.in");

const MADVolunteerDashboardTabComponent = () => {
  const userData = useGetQueryData("userData");
  const user = userData?.user;

  if (isOoloilabsSuperAdmin(user)) {
    return <VolunteerDashboard />;
  }

  if (user?.profileType === "volunteers") {
    return (
      <VolunteerDashboard
        preset={{ _id: user._id, display: user.name }}
      />
    );
  }

  return null;
};

export const mad_VolunteerDashboardTab = {
  sectionId: "MADVolunteerDashboard",
  display: "Volunteer Dashboard",
  icon: "ChartBar",
  shouldShow: (user) =>
    user?.profileType === "volunteers" || isOoloilabsSuperAdmin(user),
  Component: MADVolunteerDashboardTabComponent,
};

export default mad_VolunteerDashboardTab;
